import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/tailwind.css'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import VueAxios from 'vue-axios'

import 'material-icons/iconfont/material-icons.css';
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css' //Vuesax styles
Vue.use(Vuesax, {
  // options here
})
import VueDragscroll from 'vue-dragscroll'
Vue.use(VueDragscroll)

/* VeeValidate */
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
  classes: true,
  classNames: {
    valid: "is-valid",
    invalid: "is-invalid"
  },
  fieldsBagName: 'vvFields'
});

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

/* VueCtkDateTimePicker */
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);


/* vue-moment */
const moment = require('moment')
require('moment/locale/es')
Vue.use(require('vue-moment'), {
  moment
})

/* Vue-multiselect */
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
Vue.component('multiselect', Multiselect)

Vue.config.productionTip = false
import VueLazyLoad from "vue-lazyload";
Vue.use(VueLazyLoad);

import "vue-pdf-app/dist/icons/main.css";
import VuePdfApp from "vue-pdf-app";
Vue.component("vue-pdf-app", VuePdfApp);

Vue.use(VueAxios, axios)

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
